<script>
export default {
  inheritAttrs: false,

  props: {
    label: {
      type: String,
      required: true,
    },

    error: {
      type: Boolean,
      default: false,
    },

    selected: {
      type: Boolean,
      default: false,
    },

    value: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onChange(event) {
      this.$emit('input', event.target.checked)
      this.$emit('change', event.target.checked)
    },
  },
}
</script>

<template>
  <label :class="{ 'text-error': error }">
    <div class="mb-2 font-medium whitespace-no-wrap">
      <input
        type="checkbox"
        v-bind="$attrs"
        class="bg-white focus:outline-none border border-gray-300 rounded py-3 px-4 leading-normal mr-1"
        :class="{ 'border-error': error }"
        :checked="value"
        @change="onChange"
      />
      {{ label }}
    </div>
  </label>
</template>
